import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, CardMedia, CircularProgress } from '@mui/material';
import { awardService } from '../services/api';
import { getImageUrl } from '../utils/assets';
import SimplePageBanner from '../components/SimplePageBanner';
import { bodyTextSx, cardSx, BRAND, COLORS, sectionPaddingSx, cardHeadingSx } from '../theme/pageStyles';

const AwardsPage = () => {
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAwards = async () => {
      try {
        const response = await awardService.getAllAwards();
        setAwards(response.data?.data || response.data || []);
      } catch (error) {
        console.error('Error fetching awards:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAwards();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress sx={{ color: BRAND.green }} />
      </Box>
    );
  }

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <SimplePageBanner
        subtitle="Recognition"
        title="Awards & Recognition"
        description="Our commitment to excellence and meaningful social impact."
      />

      <Box sx={{ backgroundColor: '#FAF9F6', ...sectionPaddingSx }}>
      <Container maxWidth={false} sx={{ width: '100%', px: { xs: 2, sm: 3 } }}>
        {awards.length === 0 ? (
          <Typography sx={{ ...bodyTextSx, textAlign: 'center', color: COLORS.body }}>No awards available</Typography>
        ) : (
          <Grid container spacing={4}>
            {awards.map(award => (
              <Grid item xs={12} md={6} key={award.id}>
                <Card sx={{ display: 'flex', height: '100%', ...cardSx }} elevation={0}>
                  <CardMedia
                    component="img"
                    sx={{ width: 200, objectFit: 'cover' }}
                    image={getImageUrl(award.image_url) || 'https://via.placeholder.com/200x200?text=' + encodeURIComponent(award.title)}
                    alt={award.title}
                  />
                  <CardContent sx={{ flex: 1, p: 3 }}>
                    <Typography sx={{ ...cardHeadingSx, color: BRAND.green, mb: 1 }}>{award.title}</Typography>
                    <Typography sx={{ ...bodyTextSx, fontSize: 13, mb: 0.5 }}>{award.awarding_organization}</Typography>
                    <Typography sx={{ ...bodyTextSx, fontSize: 12, mb: 1.5 }}>{award.award_date && new Date(award.award_date).toLocaleDateString()}</Typography>
                    <Typography sx={{ ...bodyTextSx, fontSize: 13 }}>{award.description}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
      </Box>
    </Box>
  );
};

export default AwardsPage;
